export const MODO_VISAO = {
  GridCarregada: 1,
  GridVazia: 2,
  Manutencao: 3,
};
